import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { CreateOrganizationFundParams, OrganizationFundResponse } from './types';

export async function createOrganizationFund(organizationId: string, params: CreateOrganizationFundParams) {
  const url = `/web/studio/organizations/${organizationId}/funds`;

  const body = {
    name: params.name,
    default: params.isDefault ?? false,
  };

  const response = await api.executePostRequest<ObjectResponse<OrganizationFundResponse>>(url, body);

  return response.data;
}
